import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { VueFlux, FluxControls, FluxPagination } from "vue-flux";
import { scrollTo } from "@/js/animation";
import { isUserBuyerGroup, hasRole } from "@/js/http/auth";
import returnComponent from "@/components/navigation/ReturnToList.vue";
import Map from "@/components/map/Map.vue";
import RegionFormModal from "@/components/region/RegionFormModal";
export default {
  name: "regionComponent",
  components: {
    return: returnComponent,
    VueFlux: VueFlux,
    FluxControls: FluxControls,
    FluxPagination: FluxPagination,
    Map: Map,
    RegionFormModal: RegionFormModal
  },
  props: {
    loggedUserData: Object,
    region: {}
  },
  data: function data() {
    return {
      canManageRegions: false,
      defaultImage: false,
      vueFlux: {
        images: [],
        options: {
          autoplay: true
        },
        transitions: [],
        transitionsStandard: ["slide"],
        transitionsAll: [
        //"fade",
        //"kenburn",
        //"swipe",
        "slide"
        //"waterfall",
        //"zip",
        //"blinds2d",
        //"blocks2",
        //"concentric",
        //"warp",
        //"cube",
        //"book",
        //"fall",
        //"wave",
        //"blinds3d",
        //"round1",
        //"round2",
        //"explode"
        ]
      },
      id: null,
      activeSubRegion: null,
      mapFailedLoading: false,
      wineryImagesBroken: [],
      editModalShown: false,
      editModalHasDoneUpdate: false
    };
  },
  computed: {
    regionAddress: function regionAddress() {
      return "".concat(this.region.administrativeName, ", ").concat(this.region.country.printable_name);
    },
    regionType: function regionType() {
      var _this$$route$query;
      if ((_this$$route$query = this.$route.query) !== null && _this$$route$query !== void 0 && _this$$route$query.type) return this.$route.query.type;
      if (this.region.isSpirits) {
        return "spirits";
      } else {
        return "wines";
      }
    },
    regionWithSubsSorted: function regionWithSubsSorted() {
      return _objectSpread(_objectSpread({}, this.region), {}, {
        regionSubs: this.region.regionSubs.map(function (subRegion) {
          return _objectSpread(_objectSpread({}, subRegion), {}, {
            producers: subRegion.producers.sort(function (a, b) {
              if (a.nbProducts === 0 && b.nbProducts !== 0) {
                return 1;
              }
              if (b.nbProducts === 0 && a.nbProducts !== 0) {
                return -1;
              }
              return 0;
            })
          });
        }).sort(function (a, b) {
          if (a.producers.length === 0 && b.producers.length !== 0) {
            return 1;
          }
          if (b.producers.length === 0 && a.producers.length !== 0) {
            return -1;
          }
          return 0;
        })
      });
    }
  },
  created: function created() {
    var _this$region$images;
    this.canManageRegions = hasRole(process.env.VUE_APP_ROLES_MANAGE_APPELLATION);
    if (((_this$region$images = this.region.images) === null || _this$region$images === void 0 ? void 0 : _this$region$images.length) > 0) {
      this.vueFlux.images = _toConsumableArray(this.region.images.map(function (x) {
        return x.absoluteUri;
      }));
      /*
      const shuffled = this.vueFlux.transitionsAll.sort(() => 0.5 - Math.random())
      this.vueFlux.transitions = shuffled.slice(0, 3)
      */
      this.vueFlux.transitions = _toConsumableArray(this.vueFlux.transitionsStandard);
    } else {
      this.defaultImage = true;
    }
  },
  mounted: function mounted() {
    if (this.$route.query.idSubRegion) {
      this.visibleSubRegion(this.$route.query.idSubRegion, true);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.prevRoute = from;
    });
  },
  methods: {
    selectWinery: function selectWinery(producerId) {
      var searchCriterias = {
        idRegionOrigin: this.$props.region.id
      };
      var param = {
        id_region: this.$props.region.id
      };
      return {
        name: isUserBuyerGroup(this.loggedUserData) ? "userProducerDetails" : "adminProducerDetails",
        params: {
          id: producerId,
          searchCriterias: searchCriterias,
          isDistillery: this.regionType === "spirits",
          isWinery: this.regionType !== "spirits",
          returnRoute: "userRegionDetails",
          returnParam: param
        },
        query: this.$route.query
      };
    },
    visibleSubRegion: function visibleSubRegion(idSubRegion) {
      var preventChangeRouter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.activeSubRegion = idSubRegion;
      var query = Object.flat(_objectSpread(_objectSpread({}, this.$route.query), {}, {
        idSubRegion: idSubRegion
      }));
      if (!preventChangeRouter) this.$router.replace({
        query: query
      });
      this.$nextTick(function () {
        scrollTo("#subregion-details");
      });
    },
    openEditModal: function openEditModal() {
      var _this = this;
      this.editModalShown = true;
      this.$nextTick(function () {
        _this.$refs.regionForm.open();
      });
    },
    refreshPage: function refreshPage() {
      window.location.reload();
    }
  }
};